/**
 * arama.tsx
 *
 * NE İŞE YARAR : Üst çubuktaki kişi araması — yazılan metin `M3-01`in `q` filtresine gider
 * KAYNAK SPEC  : 15-arayuz-standardi.md §5.1 (üst çubuk) · §8.1 (arama)
 *                04-api-sozlesmesi.md M3-01 · 01-veri-modeli.md §12 (`tr_normalize`)
 * BAĞLI OLDUĞU : react-router · src/yetki (izin) · kişi listesi ekranı
 * KULLANAN     : src/kabuk/kabuk.tsx
 * DİKKAT       : 1) ARAMA **KENDİ SONUÇ EKRANI OLMAYAN** BİR KISAYOLDUR. Yazılan metin
 *                   kişi listesine `?q=` olarak taşınır; ayrı bir *"arama sonuçları"*
 *                   ekranı yazılsaydı aynı listenin ikinci bir kopyası olurdu ve sütun
 *                   süzme, sayfalama, yetki kuralları iki yerde tutulurdu.
 *                2) YALNIZ KİŞİDE ARAR ve bu bilinçlidir. `04` §5'te `q` filtresi olan
 *                   iki uç var (`M3-01`, `M5-01`); ikisinde birden arayan bir kutu iki
 *                   istek atar ve sonuçları **birleştirmek** zorunda kalırdı — hangi
 *                   satırın hangi varlık olduğu kaybolurdu. Kişi seçildi çünkü öğrenci
 *                   de bir kişidir; tersi doğru değildir.
 *                3) `person.read` YOKSA KUTU **HİÇ ÇİZİLMEZ** (`15` §7.1). Pasif bir
 *                   arama kutusu, kullanıcıya göremeyeceği bir veri olduğunu söylerdi.
 *                4) BOŞ ARAMA GEZİNMEZ. `Enter`a boş kutuyla basmak listeyi filtresiz
 *                   açardı; kullanıcı bunu istemiyor, yalnız kutuya tıklamış oluyor.
 *                5) NORMALLEŞTİRME **SUNUCUDADIR** (`01` §12). İstemci `tr_normalize`
 *                   uygulamaz; uygulasaydı aynı mantık iki yerde durur ve ayrıştıklarında
 *                   arama sessizce yanlış sonuç verirdi.
 * SON GÜNCELLEME: 2026-08-31 12:40:00
 */
import { TextInput } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useState, type ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

import { metin } from '../metin';
import { useOturum } from '../oturum/baglam';

export function UstCubukArama(): ReactElement | null {
  const { izinVar } = useOturum();
  const yonlendir = useNavigate();
  const [taslak, setTaslak] = useState('');

  // Başlıktaki not 3.
  if (!izinVar('person.read')) {
    return null;
  }

  function ara(): void {
    const metinDegeri = taslak.trim();
    if (metinDegeri === '') {
      // Başlıktaki not 4.
      return;
    }
    // Başlıktaki not 1 — kısayol, kendi ekranı değil.
    // `void` — yönlendirici bir `Promise` döndürür; beklenecek bir sonucu yoktur.
    void yonlendir(`/kisiler?q=${encodeURIComponent(metinDegeri)}`);
  }

  return (
    <TextInput
      // Etiket görsel olarak yok ama **ekran okuyucu için var** (`15` §13):
      // yalnız yer tutucuya güvenmek, alanın adını odaklanınca kaybederdi.
      aria-label={metin('arama.etiket')}
      placeholder={metin('arama.yerTutucu')}
      leftSection={<IconSearch size={16} />}
      value={taslak}
      onChange={(olay) => setTaslak(olay.currentTarget.value)}
      onKeyDown={(olay) => {
        if (olay.key === 'Enter') {
          ara();
        }
      }}
      w={260}
      visibleFrom="sm"
    />
  );
}
